<template>
    <div class="ibox float-e-margins">
        <div class="ibox-title">
            <h5>Editor de Páginas</h5>
        </div>
        <div class="ibox-content">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group"
                            :class="{ 'has-error': form.errors.has('title') }"
                    >
                        <label for="title" class="control-label">Titulo</label>
                        <input type="text"
                                class="form-control"
                                v-model="form.title"
                                @blur="slugifyTitle"
                        >
                        <span class="help-block" v-if="form.errors.has('title')">
                            {{ form.errors.first('title') }}
                        </span>
                    </div>
                    <div class="form-group"
                            :class="{ 'has-error': form.errors.has('slug') }"
                    >
                        <label for="slug" class="control-label">Url</label>
                        <input placeholder="Usar-hífen-em-vez-de-espaços"
                                type="text"
                                class="form-control"
                                v-model="form.slug"
                        >
                        <span class="help-block" v-if="form.errors.has('slug')">
                            {{ form.errors.first('slug') }}
                        </span>
                    </div>
                </div>
                <div class="col-md-12">
                    <quill-editor v-model="form.body"
                                  :options="editorOptions"
                    ></quill-editor>
                    <span class="help-block" v-if="form.errors.has('body')">
                        {{ form.errors.first('body') }}
                    </span>
                </div>
                <div class="col-md-12 m-t">
                    <button class="btn btn-lg btn-primary"
                            @click.prevent="onSubmit"
                    >
                        Salvar
                    </button>
                    <button class="btn btn-lg btn-clear"
                            @click.prevent="onDelete"
                            v-if="!isNew"
                    >
                        Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import slugify from 'slugify';
import Form from 'form-backend-validation';
import { quillEditor } from 'vue-quill-editor';

export default {
    props: {
        page: {
            type: Object,
            default() {
                return {
                    title: null,
                    slug: null,
                    body: null,
                };
            },
        },
        method: {
            type: String,
        },
        action: {
            type: String,
        },
    },
    components: {
        quillEditor,
    },
    data() {
        return {
            form: new Form(this.page),
            editorOptions: {
                placeholder: 'HTML da sua página',
            },
        };
    },
    computed: {
        isNew() {
            return this.method === 'post';
        },
    },
    methods: {
        onSubmit() {
            this.form[this.method](this.action)
                .then(() => {
                    toastr.success('Página salva com sucesso');
                    location.href = '/admin/pages';
                })
                .catch((error) => {
                    toastr.error('Erro ao criar página');
                });
        },
        onDelete() {
            axios.delete(this.action)
                .then(() => {
                    toastr.success('Página excluida com sucesso');
                    location.href = '/admin/pages';
                })
                .catch((error) => {
                    toastr.error('Erro ao excluir página');
                });
        },
        slugifyTitle() {
            const { title, slug } = this.form;

            if (!slug && title) {
                this.form.slug = slugify(title).toLowerCase();
            }
        },
    },
}
</script>
